// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhPD0{width:100%}.taXg1{color:#5d748c}", ""]);
// Exports
exports.locals = {
	"root": "vhPD0",
	"checkSpam": "taXg1"
};
module.exports = exports;
